import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { App } from "./App";
import { I18nextProvider } from "react-i18next";
import i18next from "./translations/index";
import { SnackbarProvider } from "notistack";
import {
  ethicsSuccess,
  ethicsError,
  ethicsInfo,
  ethicsWarning,
} from "./components/Flags/AlertFlags";
import useCustomTheme from "./theme/themeMUI/useCustomTheme";
import { CssBaseline, ThemeProvider } from "@mui/material";

// Suppress benign ResizeObserver error in development
const resizeObserverErr = (e) => {
  if (e.message?.includes("ResizeObserver loop")) {
    const resizeObserverErrDiv = document.getElementById("webpack-dev-server-client-overlay-div");
    const resizeObserverErrOverlay = document.getElementById("webpack-dev-server-client-overlay");
    if (resizeObserverErrDiv) resizeObserverErrDiv.style.display = "none";
    if (resizeObserverErrOverlay) resizeObserverErrOverlay.style.display = "none";
    e.stopImmediatePropagation();
  }
};
window.addEventListener("error", resizeObserverErr);
window.addEventListener("error", resizeObserverErr, true);

const container = document.getElementById("root");
const root = createRoot(container);

const Main = () => {
  const theme = useCustomTheme();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        Components={{
          success: ethicsSuccess,
          error: ethicsError,
          warning: ethicsWarning,
          info: ethicsInfo,
        }}
        maxSnack={5}
        autoHideDuration={5000}
      >
        <App tab="home" />
      </SnackbarProvider>
    </ThemeProvider>
  );
};

root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18next}>
      <Main />
    </I18nextProvider>
  </Provider>
);
